import { Component, OnInit } from '@angular/core';
import { getLongDate, getStringDate } from 'src/app/common/util';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { BalanceResponse } from 'src/app/models/balanceresponse.model';
import { UserSaved } from 'src/app/models/user.model';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/services/company.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { HttpErrorResponse } from '@angular/common/http';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { catchError, tap } from 'rxjs/operators';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { of } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { UserAdministrativeResponse, WarehouseDayXMLResponse } from 'src/app/models/advance-transfer.model';

@Component({
  selector: 'app-administrative-information',
  templateUrl: './administrative-information.component.html',
  styleUrls: ['./administrative-information.component.scss']
})
export class AdministrativeInformationComponent {
  balances: { [companyId: string]: any } = {};
  companyInfos: { [companyId: string]: { nitCompany: string, nameCompany: string } } = {};
  user: UserSaved = null;
  companies = [];
  allCompanies = [];
  inputCompany = new InputAutocompleteModel("", false, false, "", "", "", "", [], []);
  selected = null;
  timeout = null;
  pagination = new PaginationModel(0, 5, 0, 0, [], []);
  buttonSave = new ButtonLoading("btn-success", false, "BUSCAR", "fa-search");
  sortedBalances: any[] = [];
  sortColumn: string = '';
  sortDirection: string = 'asc';
  sought = false;
  inputPartner = new InputAutocompleteModel("", false, false, "", "", "", "", [], []);
  selectedPartner = null;
  partners = [];
  allPartners = [];
  filterPartner = "";
  timeoutPartner = null;
  showPartnerFilter = false;
  minimized: {[key:string]:boolean} = {};

  buttonBlockPartner = new ButtonLoading("btn-danger", false, "Bloquear Partner", "fa-lock");
  partnerIsBlocked = false;

  years: number[] = [2021, 2022, 2023, 2024, 2025, 2026];
  months = [
    { value: 1, name: 'Enero' },
    { value: 2, name: 'Febrero' },
    { value: 3, name: 'Marzo' },
    { value: 4, name: 'Abril' },
    { value: 5, name: 'Mayo' },
    { value: 6, name: 'Junio' },
    { value: 7, name: 'Julio' },
    { value: 8, name: 'Agosto' },
    { value: 9, name: 'Septiembre' },
    { value: 10, name: 'Octubre' },
    { value: 11, name: 'Noviembre' },
    { value: 12, name: 'Diciembre' }
  ];

  selectedYear: number;
  selectedMonth: number;
  daysWarehouseXML: { name: any, elements: WarehouseDayXMLResponse[], isXMLE: boolean } = null;
  usersAdministrative: { name: any, elements: UserAdministrativeResponse[] } = null;

  constructor(private accountingReport: AccountingReportService,
    private authService: AuthenticationService,
    private companyService: CompanyService,
    private toastService: ToastrService,
    private userService: UserService) { }


  ngOnInit(): void {
    const domain = window.location.hostname;

    if (domain.includes('alfayomega')){
      this.years = [2026, 2027, 2028, 2029, 2030];
    }

    this.user = JSON.parse(this.authService.getCurrentUser());
    this.companies = Object.assign(this.companies, this.user.companyRoles);
    this.allCompanies = this.companies;
    this.partners = [...this.partners]
    this.allPartners = [...this.partners]
    if (this.user.contadorGT || this.user.userPartner) {
      this.showPartnerFilter = false;
      this.getAssociatedCompanies(this.user.id);
      this.getAllBalances();
    }
    if (!this.user.contadorGT && !this.user.userPartner) {
      this.showPartnerFilter = true;
      this.getPartners();
    }
    this.selectedYear = 2024;
    if (domain.includes('alfayomega')){
      this.selectedYear = 2026;
    }
    this.selectedMonth = 1;
  }

  minimize(displayId, isMinimize = true){
    this.minimized[displayId] = isMinimize;
  }

  getDisplayWarehouseDaysWithoutXmlE(companyId) {
    this.accountingReport.displayWarehouseDaysWithoutXmlE(companyId, this.selectedYear, this.selectedMonth).subscribe({
      next: (response: ResponseObject) => {
        this.daysWarehouseXML = { name: this.getBalanceById(companyId, 'nameCompany'), elements: response.data, isXMLE: true };
      },
      error: (error) => {
        this.toastService.error(error);
      }
    })
  }

  getDisplayWarehouseDaysWithoutXmlR(companyId) {
    this.accountingReport.displayWarehouseDaysWithoutXmlR(companyId, this.selectedYear, this.selectedMonth).subscribe({
      next: (response: ResponseObject) => {
        this.daysWarehouseXML = { name: this.getBalanceById(companyId, 'nameCompany'), elements: response.data, isXMLE: false };
      },
      error: (error) => {
        this.toastService.error(error);
      }
    })
  }

  getUsersAdministrative(companyId) {
    this.accountingReport.displayUsersByCompany(companyId).subscribe({
      next: (response: ResponseObject) => {
        this.usersAdministrative = { name: this.getBalanceById(companyId, 'nameCompany'), elements: response.data };
      },
      error: (error) => {
        this.toastService.error(error);
      }
    })
  }

  cropName(name) {
    let forCrop = name;
    if (forCrop) {
      var cropped = forCrop.slice(0, 40);
      return cropped + (name.length > 40 ? '...' : '');
    } else {
      return "";
    }
  }

  getAllBalances(): void {
    if (this.buttonSave.loading) {
      return;
    }
    this.balances = {};
    this.companyInfos = {};
    var companyId = this.selected ? (this.selected.companyId ? this.selected.companyId : this.selected.id) : null;
    this.buttonSave.loading = true;
    if (companyId) {
      this.getResultsAdministrative(companyId).subscribe({
        next: (response: BalanceResponse) => {
          if (response.success) {
            this.balances[companyId] = {
              data: response.data
            };
            this.sortedBalances = Object.keys(this.balances).map(companyId => {
              return { companyId, ...this.balances[companyId] };
            });
            this.pagination.total = this.getCompanyIds();
            this.resetPagination(this.pagination);
          }
        }, error: (error: HttpErrorResponse) => {
          this.sought = true;
          this.buttonSave.loading = false;
        }, complete: () => {
          this.sought = true;
          this.buttonSave.loading = false;
        }
      });
    } else {
      const requests = this.companies.map(company =>
        this.getResultsAdministrative((company.companyId ? company.companyId : company.id)).pipe(
          tap((response: BalanceResponse) => {
            if (response.success) {
              this.balances[(company.companyId ? company.companyId : company.id)] = {
                data: response.data
              };
              this.companyInfos[(company.companyId ? company.companyId : company.id)] = {
                nitCompany: response.data.nitCompany,
                nameCompany: response.data.nameCompany
              };
              this.sortedBalances = Object.keys(this.balances).map(companyId => {
                return { companyId, ...this.balances[companyId] };
              });
              this.pagination.total = this.getCompanyIds();
              this.resetPagination(this.pagination);
            }
          }),
          catchError((error: HttpErrorResponse) => {
            return of(null);
          })
        )
      );

      forkJoin(requests).subscribe({
        next: () => {
          this.sought = true;
          this.buttonSave.loading = false;
        },
        complete: () => {
          this.sought = true;
          this.buttonSave.loading = false;
        }
      });
    }

  }

  filter() {
    this.getAllBalances();
  }

  getBalanceById(companyId: string, displayId: string): number {
    const balanceData = this.balances[companyId];
    if (balanceData) {
      const data = balanceData.data;
      return data[displayId] ? data[displayId] : 0;
    }
    return 0;
  }

  getAssociatedCompanies(idPartner: number) {
    this.companyService.getCompaniesAssociatedToPartner(idPartner).subscribe({
      next: (response: ResponseObject) => {
        this.companies = response.data;
        this.allCompanies = this.companies;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las companias asociadas");
      }
    })
  }

  getResultsAdministrative(companyId: any) {
    return this.accountingReport.getResultsAdministrative(companyId, this.selectedYear, this.selectedMonth);
  }


  getCompanyIds(): string[] {
    return this.sortedBalances.map(balance => balance.companyId);
  }

  selectCompany(selected: any) {
    clearTimeout(this.timeout);
    this.inputCompany.value = selected.alphanumericId + " - " + (selected.companyNIT || selected.nit) + " - " + (selected.companyName || selected.name);
    this.inputCompany.verified = true;
    this.inputCompany.class = "fa-circle-check";
    this.selected = selected;
    //this.filter();
  }

  searchCompany() {
    clearTimeout(this.timeout);
    this.inputCompany.class = "typing";
    this.selected = null;
    this.timeout = setTimeout(() => {
      this.companies = this.allCompanies.filter((company) => {
        var val = this.inputCompany.value.toLowerCase();
        return company.alphanumericId.toLowerCase() == val || company.companyName?.toLowerCase().includes(val) || company.companyNIT?.toLowerCase().includes(val)
          || company.name?.toLowerCase().includes(val) || company.nit?.toLowerCase().includes(val);
      });
      this.inputCompany.verified = false;
      if (this.companies.length > 0) {
        this.inputCompany.class = "fa-list";
      } else {
        this.inputCompany.class = "fa-xmark";
      }
      if (!this.inputCompany.value.toLowerCase()) {
        this.selected = null;
        //this.filter();
      }
    }, 300);
  }

  resetPagination(paginationTemp) {
    paginationTemp.startElement = 0;
    paginationTemp.pageIndex = 0;
    paginationTemp.lastElement = paginationTemp.pageSize;
    paginationTemp.filter = paginationTemp.total.slice(paginationTemp.startElement, paginationTemp.lastElement);
    paginationTemp.lastElement = paginationTemp.filter.length;
  }

  sort(displayId: string) {
    if (this.sortColumn === displayId) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortDirection = 'asc';
    }
    this.sortColumn = displayId;

    this.sortedBalances.sort((a, b) => {

      const totalA = a.data[displayId]
      const totalB = b.data[displayId]

      if (totalA < totalB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (totalA > totalB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.sortCompanyInfosByBalances();
  }


  sortCompanyInfosByBalances() {
    const sortedCompanyInfos: any[] = [];

    this.sortedBalances.forEach((balance) => {
      const companyId = balance.companyId;

      if (this.companyInfos[companyId]) {
        sortedCompanyInfos.push({
          companyId: companyId,
          ...this.companyInfos[companyId]
        });
      }
    });

    this.pagination.total = this.getCompanyIds();
    this.resetPagination(this.pagination);
  }

  getPartners() {
    this.userService.getPartnersWithoutSizeAndPageAndFilter()
      .subscribe({
        next: (response: ResponseObject) => {
          this.partners = response.data.partners;
          this.allPartners = this.partners;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      });
  }

  selectPartner(selected: any) {
    clearTimeout(this.timeoutPartner);
    this.inputPartner.value = selected.name + '-' + selected.email;
    this.inputPartner.verified = true;
    this.inputPartner.class = "fa-circle-check";
    this.selectedPartner = selected;
    this.getAssociatedCompanies(selected.id);
    this.getIsBlockerPartner();
  }

  searchPartner() {
    clearTimeout(this.timeoutPartner);
    this.inputPartner.class = "typing";
    this.selectedPartner = null;
    this.timeoutPartner = setTimeout(() => {
      this.partners = this.allPartners.filter((partner) => {
        var val = this.inputPartner.value.toLowerCase();
        return partner.id == val || partner.email?.toLowerCase().includes(val) || partner.name?.toLowerCase().includes(val);
      });
      this.inputPartner.verified = false;
      if (this.partners.length > 0) {
        this.inputPartner.class = "fa-list";
      } else {
        this.inputPartner.class = "fa-xmark";
      }
      if (!this.inputPartner.value.toLowerCase()) {
        if (!this.user.contadorGT && !this.user.userPartner) {
          this.companies = Object.assign(this.companies, this.user.companyRoles);
          this.allCompanies = this.companies;
        } else if (this.user.contadorGT || this.user.userPartner) {
          this.getAssociatedCompanies(this.user.id);
        }
        this.selectedPartner = null;
      }

    }, 300);
  }

  getIsBlockerPartner() {
    if (this.selectedPartner) {
      this.accountingReport.getPartnerIsBlocked(this.selectedPartner.id).subscribe({
        next: (response: ResponseObject) => {
          this.partnerIsBlocked = response.data;
          this.validateButtonBlockPartner();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al verificar si el socio esta bloqueado.");
        }
      })
    }
  }

  blockPartner() {
    if (this.selectedPartner) {
      if (this.partnerIsBlocked) {
        this.accountingReport.unblockPartner(this.selectedPartner.id).subscribe({
          next: (response: ResponseObject) => {
            this.partnerIsBlocked = response.data;
            if (Object.keys(this.balances).length > 0) {
              this.getAllBalances();
            }
            this.getIsBlockerPartner();
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al desbloquear el partner");
          }
        })
      } else {
        this.accountingReport.blockPartner(this.selectedPartner.id).subscribe({
          next: (response: ResponseObject) => {
            this.partnerIsBlocked = response.data;
            if (Object.keys(this.balances).length > 0) {
              this.getAllBalances();
            }
            this.getIsBlockerPartner();
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al bloquear el partner");
          }
        })
      }

    }
  }

  validateButtonBlockPartner() {
    if (this.partnerIsBlocked == false) {
      this.buttonBlockPartner = new ButtonLoading("btn-danger", false, "Bloquear Partner", "fa-lock");
    } else {
      this.buttonBlockPartner = new ButtonLoading("btn-warning", false, "Desbloquear Partner", "fa-unlock");
    }
  }

  blockCompanyButton(companyId: string) {
    this.blockCompany(companyId);
  }

  blockCompany(companyId: string) {
    this.accountingReport.blockCompany(companyId).subscribe({
      next: (response: ResponseObject) => {
        this.getAllBalances();
        this.getIsBlockerPartner();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al bloquear la compania");
      }
    })
  }

  unBlockCompanyButton(companyId: string) {
    this.unBlockCompany(companyId);
  }

  unBlockCompany(companyId: string) {
    this.accountingReport.unblockCompany(companyId).subscribe({
      next: (response: ResponseObject) => {
        this.getAllBalances();
        this.getIsBlockerPartner();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al desbloquear la compania");
      }
    })
  }

}
